(() => {
  function initEllaCart() {
    const cartPanel = document.getElementById('HeaderCart');
    const cartTrigger = document.getElementById('HeaderCartTrigger');
    if (cartPanel && cartTrigger && cartPanel.querySelector('form') && cartPanel.querySelector('[data-products]') && !cartTrigger.dataset.ellaManualCart) {
      cartTrigger.dataset.ellaManualCart = 'true';
      document.body.append(cartPanel);
      cartPanel.classList.add('ella-side-cart');
      cartPanel.setAttribute('role', 'dialog');
      cartPanel.setAttribute('aria-modal', 'true');
      cartPanel.setAttribute('aria-labelledby', 'ella-cart-title');
      const backdrop = document.createElement('div');
      backdrop.className = 'ella-cart-backdrop';
      document.body.append(backdrop);
      const heading = document.createElement('div');
      heading.className = 'ella-cart-heading';
      heading.innerHTML = '<h2 id="ella-cart-title">Dein Warenkorb <span data-ella-cart-count></span></h2><button type="button" data-ella-cart-close aria-label="Warenkorb schließen">×</button>';
      const shipping = document.createElement('div');
      shipping.className = 'ella-cart-shipping';
      shipping.innerHTML = '<p>Versandkosten werden berechnet …</p>';
      cartPanel.prepend(heading);
      const form = cartPanel.querySelector('form');
      const scrollable = form.querySelector('.cart__scrollable');
      scrollable.prepend(shipping);
      const footer = cartPanel.querySelector('.cart__footer');
      if (form && footer) form.append(footer);
      const checkout = cartPanel.querySelector('[name="checkout"]');
      if (checkout) checkout.textContent = 'Zur Kasse';
      const savings = document.createElement('div');
      savings.className = 'ella-cart-saving';
      footer?.prepend(savings);
      let contentsRequest = 0;
      let changingQuantity = false;
      async function refreshCartContents() {
        const request = ++contentsRequest;
        const url = new URL(form.action, window.location.origin);
        url.searchParams.set('view', 'ajax');
        const response = await fetch(url, {credentials: 'same-origin', cache: 'no-store'});
        if (!response.ok) throw new Error('cart');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const items = html.querySelector('.cart__items');
        if (!items || request !== contentsRequest) return;
        const discounts = html.querySelector('.cart__discounts');
        const currency = shipping.querySelector('[data-currency]')?.dataset.currency || window.Shopify?.currency?.active || 'EUR';
        const subtotal = new Intl.NumberFormat('de-DE', {style:'currency',currency}).format(Number(items.dataset.cartSubtotal) / 100);
        for (const target of [form, document.getElementById('CartPageForm')].filter(Boolean)) {
          target.querySelector('[data-products]')?.replaceChildren(...Array.from(items.childNodes, node => node.cloneNode(true)));
          const total = target.querySelector('[data-subtotal]');
          if (total) total.textContent = subtotal;
          const discountTarget = target.querySelector('[data-discounts]');
          if (discountTarget) discountTarget.replaceChildren(...(discounts ? [discounts.cloneNode(true)] : []));
        }
        const empty = cartPanel.querySelector('.site-header__cart-empty');
        if (empty) empty.hidden = Number(items.dataset.count) > 0;
      }
      async function changeQuantity(input, quantity) {
        if (changingQuantity || !Number.isInteger(quantity) || quantity < 0) return;
        const item = input.closest('.cart__item');
        const products = item?.closest('[data-products]');
        const line = products ? [...products.querySelectorAll('.cart__item')].indexOf(item) + 1 : 0;
        if (!line) return;
        changingQuantity = true;
        const controls = [...cartPanel.querySelectorAll('.js-qty__adjust, .js-qty__num'), ...document.querySelectorAll('#CartPageForm .js-qty__adjust, #CartPageForm .js-qty__num')];
        controls.forEach(control => { control.disabled = true; });
        if (checkout) checkout.disabled = true;
        try {
          const url = new URL(form.action, window.location.origin);
          url.pathname = url.pathname.replace(/\/$/, '') + '/change.js';
          const response = await fetch(url, {
            method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'},
            body: JSON.stringify({line, quantity})
          });
          if (!response.ok) throw new Error('quantity');
          await refreshCartContents();
          await refreshCartStatus();
        } catch (error) {
          notice.textContent = 'Die Warenkorbänderung konnte gerade nicht bestätigt werden. Bitte lade den Warenkorb erneut.';
          notice.hidden = false;
        } finally {
          controls.forEach(control => { control.disabled = false; });
          changingQuantity = false;
          refreshCartStatus();
        }
      }
      document.addEventListener('click', event => {
        const control = event.target.closest('#HeaderCart .js-qty__adjust, #CartPageForm .js-qty__adjust, #HeaderCart .cart__remove a, #CartPageForm .cart__remove a');
        if (!control) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const input = control.closest('.cart__item').querySelector('.js-qty__num');
        const quantity = control.closest('.cart__remove') ? 0 : Math.max(0, Number(input.value) + (control.classList.contains('js-qty__adjust--plus') ? 1 : -1));
        changeQuantity(input, quantity);
      }, true);
      let quantityInputTimer;
      document.addEventListener('input', event => {
        const input = event.target.closest('#HeaderCart .js-qty__num, #CartPageForm .js-qty__num');
        if (!input || changingQuantity) return;
        clearTimeout(quantityInputTimer);
        const value = input.value.trim();
        if (!/^\d+$/.test(value)) return;
        quantityInputTimer = setTimeout(() => {
          if (input.isConnected) changeQuantity(input, Number(value));
        }, 350);
      }, true);
      document.addEventListener('change', event => {
        const input = event.target.closest('#HeaderCart .js-qty__num, #CartPageForm .js-qty__num');
        if (!input) return;
        clearTimeout(quantityInputTimer);
        event.stopImmediatePropagation();
        if (!/^\d+$/.test(input.value.trim())) return;
        changeQuantity(input, Number(input.value));
      }, true);
      let statusRequest = 0;
      async function refreshCartStatus() {
        const request = ++statusRequest;
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', 'ella-cart-status');
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) throw new Error('status');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const status = html.querySelector('[data-ella-cart-status]');
          if (!status || request !== statusRequest) return;
          shipping.replaceChildren(status);
          const delivery = status.querySelector('[data-ella-cart-delivery]');
          const pageDelivery = document.querySelector('#CartPageForm [data-ella-cart-delivery]');
          if (delivery && pageDelivery) pageDelivery.replaceWith(delivery.cloneNode(true));
          heading.querySelector('[data-ella-cart-count]').textContent = '· ' + status.dataset.count + ' Artikel';
          const count = Number(status.dataset.count) || 0;
          document.querySelectorAll('.cart-link__bubble-num').forEach(element => { element.textContent = String(count); });
          document.querySelectorAll('.cart-link__bubble').forEach(element => { element.classList.toggle('cart-link__bubble--visible', count > 0); });
          const saving = Number(status.dataset.saving);
          savings.hidden = !saving;
          savings.textContent = saving > 0 ? 'Du sparst ' + new Intl.NumberFormat('de-DE', {style:'currency',currency:status.dataset.currency || 'EUR'}).format(saving / 100) : '';
          if (checkout) checkout.disabled = changingQuantity || Number(status.dataset.count) === 0;
          document.querySelectorAll('#CartPageForm [name="checkout"]').forEach(button => { button.disabled = changingQuantity || Number(status.dataset.count) === 0; });
        } catch (error) {
          if (request === statusRequest) shipping.textContent = 'Versandkosten und Gesamtbetrag werden im Checkout ausgewiesen.';
        }
      }
      const fitCartViewport = () => {
        const bar = document.getElementById('PBarNextFrameWrapper');
        const rect = bar?.getBoundingClientRect();
        const inset = rect?.height > 0 && rect.height < 150 && rect.bottom >= window.innerHeight - 1 ? window.innerHeight - rect.top : 0;
        cartPanel.style.setProperty('--ella-cart-bottom', inset + 'px');
      };
      window.addEventListener('resize', fitCartViewport);
      let savedOverflow = '';
      const setCartOpen = open => {
        cartPanel.classList.remove('is-transitioning');
        cartPanel.classList.toggle('is-active', open);
        document.documentElement.classList.toggle('cart-open', open);
        cartTrigger.setAttribute('aria-expanded', String(open));
        cartPanel.setAttribute('aria-hidden', String(!open));
        cartPanel.inert = !open;
        backdrop.classList.toggle('is-active', open);
        if (open) {
          savedOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          refreshCartContents().catch(() => { shipping.textContent = 'Bitte lade den Warenkorb erneut, um alle Artikel zu sehen.'; });
          fitCartViewport();
          refreshCartStatus();
          heading.querySelector('button').focus({preventScroll:true});
        } else {
          document.body.style.overflow = savedOverflow;
          cartTrigger.focus({preventScroll:true});
        }
        document.dispatchEvent(new CustomEvent('ella:cart-toggle'));
      };
      const notice = document.createElement('div');
      notice.className = 'ella-global-cart-notice';
      notice.setAttribute('role', 'status');
      notice.hidden = true;
      document.body.append(notice);
      let noticeTimer;
      document.addEventListener('ajaxProduct:added', event => {
        event.stopImmediatePropagation();
        refreshCartContents().then(refreshCartStatus).catch(() => {});
        notice.textContent = 'Zum Warenkorb hinzugefügt ✓';
        notice.hidden = false;
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          cartTrigger.animate([
            {transform:'scale(1)'},{transform:'scale(1.12)'},{transform:'scale(1)'}
          ], {duration:320,easing:'ease-out'});
          notice.animate([
            {opacity:0,transform:'translate(-50%,8px)'},
            {opacity:1,transform:'translate(-50%,0)'}
          ], {duration:240,easing:'ease-out'});
        }
        clearTimeout(noticeTimer);
        noticeTimer = setTimeout(() => { notice.hidden = true; }, 5000);
      }, true);
      document.addEventListener('cart:open', () => setCartOpen(true));
      cartPanel.inert = true;
      cartPanel.setAttribute('aria-hidden', 'true');
      document.addEventListener('cart:updated', refreshCartStatus);
      new MutationObserver(refreshCartStatus).observe(cartPanel.querySelector('[data-products]'), {childList:true});
      document.addEventListener('click', event => {
        const trigger = event.target.closest('#HeaderCartTrigger, .mob_nav_block .cart_trigger');
        const close = event.target.closest('[data-ella-cart-close], .js-close-header-cart, #HeaderCart .cart__continue, .ella-cart-backdrop');
        if (trigger || close) {
          event.preventDefault();
          event.stopImmediatePropagation();
          setCartOpen(trigger ? !cartPanel.classList.contains('is-active') : false);
        }
      }, true);
      document.addEventListener('keydown', event => {
        if (!cartPanel.classList.contains('is-active')) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          setCartOpen(false);
        }
        if (event.key === 'Tab') {
          const controls = [...cartPanel.querySelectorAll('button:not([disabled]),a[href],input:not([disabled])')].filter(el => el.getClientRects().length);
          const first = controls[0], last = controls[controls.length-1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        }
      });
    }


  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initEllaCart, {once:true});
  else initEllaCart();
})();